var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 27 27",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(2, 1)",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7300001,8.86916671 L14.7300001,8.85833337 C13.9933334,7.5041667 12.5633334,6.58333336 10.9166667,6.58333336 C8.52250004,6.58333336 6.58333336,8.52250004 6.58333336,10.9166667 C6.58333336,12.5633334 7.5041667,13.9933334 8.85833337,14.7300001 L8.86916671,14.7300001",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7391668,11.5125001 C21.7391668,11.3175001 21.7500001,11.1225001 21.7500001,10.9166667 C21.7500001,4.93666669 16.8966667,0.0833333378 10.9166667,0.0833333378 C4.93666669,0.0833333378 0.0833333378,4.93666669 0.0833333378,10.9166667 C0.0833333378,16.8966667 4.93666669,21.7500001 10.9166667,21.7500001 C11.1225001,21.7500001 11.3175001,21.7391668 11.5125001,21.7391668",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "currentColor",
    points: "15.8079167 23.9166668 10.8939167 10.8939167 23.9166668 15.8079167 17.7882501 17.7882501"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.8354402016d5cd58bdce5ea62fb36f88.svg";
export { ForwardRef as ReactComponent };